if ((navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	))) {

	// alert('手机端')
	let dpr, rem, scale, rootWidth;
	let rootHtml = document.documentElement;
	dpr = window.devicePixelRatio || 1;
	rootWidth = rootHtml.clientWidth < 1366 ? 1366 : rootHtml.clientWidth;
	rem = rootWidth * dpr / 19.2;
	scale = 1 / dpr;
	let vp = document.querySelector('meta[name="viewport"]');
	vp.setAttribute('content', 'width=' + dpr * rootHtml.clientWidth + ',initial-scale=' + scale + ',maximum-scale=' + scale + ', minimum-scale=' + scale + ',user-scalable=no');
	rootHtml.style.fontSize = `${rem}px`;
	// console.log(abc)
	
} else {
	

	// alert('PC端')


}
